// extracted by mini-css-extract-plugin
export default {"zoomModal":"v2-z","image":"w2-z","button":"x2-z","isOverlayShown":"y2-z"};